/** @jsx React.DOM */

var React = require("react/addons");
var CodeMirror = require("codemirror");

var Editor = React.createClass({displayName: 'Editor',
  render: function() {
    return (
      React.DOM.div({className: "row"}, 
        React.DOM.div({className: "col-md-12"}, 
          React.DOM.div({ref: "editor"})
        )
      )
    );
  },

  componentWillReceiveProps: function(nextProps) {
    // if (nextProps.focus) {
    //   this.state.myCodeMirror.focus();
    // }
  },

  componentDidMount: function() {
    var $this = this;
    var element = this.refs.editor;
    var myCodeMirror = CodeMirror(element.getDOMNode(), {
      lineNumbers: true,
      // tabSize: 2,
      value: this.props.initContent,
      mode: this.props.mode,
      theme: "solarized dark"
    });

    myCodeMirror.on("change", function(CodeMirror, object) {
      $this.props.onChangeValue(myCodeMirror.getValue());
    });

    this.setState({myCodeMirror: myCodeMirror});
  }
});

module.exports = Editor;



/*****************
 ** WEBPACK FOOTER
 ** ./src/editor/components/editors/Editor.js
 ** module id = 51
 ** module chunks = 0
 **/